import { render, staticRenderFns } from "./item-composition.vue?vue&type=template&id=4a0ac747&scoped=true"
import script from "./item-composition.vue?vue&type=script&lang=js"
export * from "./item-composition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ac747",
  null
  
)

export default component.exports